var parent = require('../../es/promise');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/stable/promise/index.js